// Runtime configuration loaded from /config.json
export interface RuntimeConfig {
  env: "staging" | "prod"
  apiBaseUrl: string
  tonConnectManifestUrl: string
  /** Centrifugo WebSocket URL. Required for realtime. */
  centrifugoUrl?: string
  /** PvP Roulette room ID for Centrifugo subscription (channel: ...room:{pvpRoomId}). */
  pvpRoomId?: string
  /** Sentry DSN. If absent, Sentry is disabled (local dev, tests). */
  sentryDsn?: string | null
  /** Telegram username (with or without leading `@`) of the gift-deposit relay bot. */
  giftRelayBotHandle?: string | null
}

// Global config state - set once at app bootstrap
let runtimeConfig: RuntimeConfig | null = null

export function setRuntimeConfig(config: RuntimeConfig): void {
  runtimeConfig = config
}

export function getRuntimeConfig(): RuntimeConfig {
  if (!runtimeConfig) {
    throw new Error("Runtime config not loaded. Call loadConfig() first.")
  }
  return runtimeConfig
}
